import "./seasonal.css";

(function() {
    /**
     * GM Contabilidade - Script de Modal Sazonal (IRPF/IRPJ)
     * Otimizado para Performance e SEO Dinâmico.
     */

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1; 
    const MODAL_SHOWN_KEY = 'irpf_modal_shown';

    // Temporada: Fevereiro (2), Março (3), Abril (4)
    if (!(currentMonth >= 2 && currentMonth <= 4)) return;

    function hasModalBeenShown() {
        try {
            return sessionStorage.getItem(MODAL_SHOWN_KEY) === 'true';
        } catch {
            return false;
        }
    }

    function markModalAsShown() {
        try {
            sessionStorage.setItem(MODAL_SHOWN_KEY, 'true');
        } catch {
            // Ignora browsers/contextos onde sessionStorage não está disponível.
        }
    }

    
    // SEO deve rodar mesmo que o modal já tenha sido mostrado na sessão,
    // pois o Google Bot precisa ver o conteúdo otimizado em cada crawl.
    function updateSEO(year: number) {
        // 1. Título da Página
        document.title = `GM Contabilidade | Imposto de Renda ${year}`;

        // 2. Meta Description
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', `GM Contabilidade em SP. Especialistas em IRPF ${year}, IRPJ e Malha Fina. Declare seu Imposto de Renda com segurança e tranquilidade.`);
        }

        // 3. Open Graph (Redes Sociais)
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute('content', `GM Contabilidade | Imposto de Renda ${year}`);

        // 4. Schema.org (Dados Estruturados para o Google)
        const schemaScript = document.getElementById('schema-business');
        if (schemaScript) {
            try {
                const schema = JSON.parse(schemaScript.innerHTML);
                if (schema.hasOfferCatalog && schema.hasOfferCatalog.itemListElement) {
                    schema.hasOfferCatalog.itemListElement.forEach((offer: any) => {
                        if (offer.itemOffered.name.includes('Imposto de Renda')) {
                            offer.itemOffered.name = `Declaração de IRPF ${year} & IRPJ Profissional`;
                        }
                    });
                    schemaScript.innerHTML = JSON.stringify(schema, null, 2);
                }
            } catch (e) {
                console.error('Erro ao atualizar Schema.org:', e);
            }
        }
        console.log(`[SEO] Otimização para temporada ${year} ativada.`);
    }

    // Executa SEO imediatamente
    updateSEO(currentYear);

    // Se o modal já foi mostrado, paramos por aqui após o SEO
    if (hasModalBeenShown()) return;

    const imagePath = '/assets/seasonal/irpf-promo.jpg';

    const modalHTML = `
        <div class="irpf-modal-overlay" id="irpfModal">
            <div class="irpf-modal-container">
                <button class="irpf-modal-close" id="closeIrpfModal" aria-label="Fechar">&times;</button>
                <div class="irpf-modal-image" style="background-image: url('${imagePath}');"></div>
                <div class="irpf-modal-content">
                    <div>
                        <span class="irpf-modal-tag">Temporada ${currentYear}</span>
                        <h2 class="irpf-modal-title">Não deixe o Leão te pegar de surpresa!</h2>
                        <p class="irpf-modal-description">
                            A declaração do <strong>IRPF ${currentYear}</strong> exige atenção. Conte com nossa especialização para garantir sua tranquilidade e maximizar sua restituição.
                        </p>
                        <a href="https://wa.me/5511994605617?text=Olá! Quero ajuda com o IRPF ${currentYear}" 
                           target="_blank" class="irpf-modal-cta">
                            <i class="fa-brands fa-whatsapp text-xl"></i> Falar com Especialista
                        </a>
                        <p class="irpf-modal-footer">GM Contabilidade</p>
                    </div>
                </div>
            </div>
        </div>
    `;

    function showModal() {
        if (document.getElementById('irpfModal')) return;

        document.body.insertAdjacentHTML('beforeend', modalHTML);
        const modal = document.getElementById('irpfModal');
        const closeBtn = document.getElementById('closeIrpfModal');
        
        if (!modal || !closeBtn) return;

        const closeModal = () => {
            modal.classList.remove('active');
            markModalAsShown();
            document.removeEventListener('keydown', keydownHandler);
            setTimeout(() => modal.remove(), 500);
        };

        const keydownHandler = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
                closeModal();
            }
        };

        const activateModal = () => {
            modal.classList.add('active');
        };

        if (typeof requestAnimationFrame === 'function') {
            requestAnimationFrame(activateModal);
        } else {
            setTimeout(activateModal, 0);
        }

        closeBtn.addEventListener('click', closeModal);
        modal.addEventListener('click', (e) => {
            if (e.target === modal) closeModal();
        });
        document.addEventListener('keydown', keydownHandler);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', showModal);
    } else {
        showModal();
    }
})();
